import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";

import FormGroup from "../../common/components/form/FormGroup";
import { useAppSelector } from "../../common/hooks/useStore";
import { selectDepartmentById } from "../departments/departmentsSlice";
import { Team } from "../teams/Team";

interface TeamFormProps {
  selectedDepartmentId: string;
  team?: Team;
  onSubmit: (team: Team) => Promise<void>;
}

export default function TeamsForm(props: TeamFormProps) {
  const department = useAppSelector((state) => selectDepartmentById(state, props.selectedDepartmentId));
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<Team>({
    defaultValues: {
      ...props.team,
    },
  });
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: Team) => {
    setIsLoading(true);
    await props.onSubmit(data);
    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup label="Nume" errorMessage={errors.name?.message}>
        <InputText {...register("name", { required: "Numele este obligatoriu" })} />
      </FormGroup>
      {department?.timeTrackingEnabled && (
        <Controller
          name="hourlyRate"
          control={control}
          rules={{ required: "Pretul este obligatoriu" }}
          render={({ field, fieldState }) => (
            <FormGroup label="Pret per ora" errorMessage={fieldState.error?.message}>
              <InputNumber
                id={field.name}
                min={0}
                useGrouping={true}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(e) => field.onChange(e.value)}
              />
            </FormGroup>
          )}
        />
      )}
      <Button type="submit" className="block ml-auto" label="Salveaza" icon="pi pi-save" loading={isLoading} disabled={isLoading} />
    </form>
  );
}
